import { API_ENDPOINTS, getAuthHeaders } from '../config/api.config';
import { ActiveEditionResponse } from '../types/edition.types';

/**
 * Service pour gérer les appels API liés aux éditions des jeux universitaires
 */
export const editionService = {
  /**
   * Récupère les informations détaillées sur l'édition active
   * @returns Promesse avec les informations sur l'édition active et les lieux associés
   */
  async getActiveEditionInfo(): Promise<ActiveEditionResponse> {
    try {
      const headers = getAuthHeaders();
      const response = await fetch(API_ENDPOINTS.EDITIONS.ACTIVE_INFO, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Erreur lors de la récupération des informations sur l\'édition active:', error);
      throw error;
    }
  }
};
